import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';
import { getStoryblokAlt } from '../../helpers/common';

export default function MapsSection({ blok }) {
  const locationsRef = React.useRef();

  return (
    <div {...storyblokEditable(blok)} className="px-4 lg:px-16">
      <div className="grid sm:grid-cols-2 items-center mt-[100px] lg:mt-60 lg:mb-0 gap-x-10 lg:gap-x-0">
        <div className="text-left flex flex-col" ref={locationsRef}>
          <FancyTitle
            text={blok.title}
            tag="h2"
            className="hidden lg:block"
          />
          <div className="flex flex-col md:grid xl:grid-cols-2 gap-8">
            {blok.locations
              && blok.locations.map((item) => (
                <div
                  key={item.title}
                  className="flex items-start gap-2 lg:gap-4 lg:text-xl lg:leading-8 leading-8"
                >
                  <FontAwesomeIcon
                    icon={icon(faLocationDot)}
                    className="mt-2"
                  />
                  <div>
                    <div className="text-latori-green-dark font-bold">{item.title}</div>
                    {render(item.adress, {
                      markResolvers: {
                        [MARK_LINK]: LinkResolver,
                      },
                      nodeResolvers: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        [NODE_PARAGRAPH]: (children) => (
                          <p className="flex items-start gap-2 lg:gap-4 lg:text-xl lg:leading-8 leading-8">{children}</p>
                        ),
                      },
                    })}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="w-full -order-1 lg:order-2">
          <FancyTitle
            text={blok.title}
            tag="h2"
            className="block lg:hidden"
          />
          <img
            className="mb-8 lg:mb-0 mt-16 lg:mt-0 sm:max-h-[600px] md:max-h[800px] lg:max-h-[unset] object-contain w-full"
            src={`${blok.image.filename}/m/800x0/filters:format(webp)`}
            srcSet={`${blok.image.filename}/m/400x0/filters:format(webp) 400w, ${blok.image.filename}/m/800x0/filters:format(webp) 800w`}
            sizes="(max-width: 640px) 100vw, 50vw"
            alt={getStoryblokAlt(blok.image, 'Latori GmbH branch location')}
            width={blok.image.filename?.split('/')[5]?.split('x')[0]}
            height={blok.image.filename?.split('/')[5]?.split('x')[1]}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
